import { render, staticRenderFns } from "./ShopItems.vue?vue&type=template&id=ea750e70&scoped=true"
import script from "./ShopItems.vue?vue&type=script&lang=js"
export * from "./ShopItems.vue?vue&type=script&lang=js"
import style0 from "./ShopItems.vue?vue&type=style&index=0&id=ea750e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea750e70",
  null
  
)

export default component.exports